import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Snooker = () => {
  return (
    <SportsLayoutComp name={'Snooker'}/>
  )
}

export default Snooker